import { useState } from 'react'

/**
 * @example { isHover, setHover } = useHover()
 */
export const useHover = (defaultState: boolean = false) => {
  const [isHover, setHover] = useState<boolean>(defaultState)

  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)

  return {
    isHover,
    setHover,
    onMouseEnter,
    onMouseLeave,
  }
}
